<div class="failed-content">
    <div *ngFor="let message of messages">{{message}}</div>
</div>
